"use strict";

/*
 * Copyright (c) 2025 Xplat-soft s.r.o.
 *
 * This source code is licensed under the terms found in the
 * LICENSE.md file in the root directory of this source tree
 * or at https://universal-sign-in.com/license
 */

import { createNanoEvents } from 'nanoevents';
export const emitter = createNanoEvents();
//# sourceMappingURL=emitter.web.js.map